import { Path } from 'react-hook-form';
import { FinanceProgramFormValues } from '../types';

export const styleFormRadioGroupProps = {
  formControlProps: { style: { gap: '0.5rem' } },
  radioProps: { style: { padding: '0 9px 0 9px' } },
};

export const displaySettingsForUpdate: Path<FinanceProgramFormValues>[] = [
  'displaySettings.showLenderLogo',
  'displaySettings.showLenderName',
  'displaySettings.showBestOptions',
  'displaySettings.showInterestRate',
  'displaySettings.showFinanceProgramDescription',
];
